<template>
	<div>
		<KButton
			height="34px"
			width="unset"
			font-weight="400"
			font-size="0.8125rem"
			border-radius="0.25rem"
			title="Exportar"
			margin-left="10px"
			margin-right="10px"
			:icon="{ color: '#8b83ba', size: '18px', type: 'file-text' }"
			@click="openModalExport"
		/>
		<Modal
			v-if="modalActive"
			:download-load="downloadLoad"
			title="Exportar"
			@download="getPedidosFilter($event)"
			@close="modalActive = false"
		/>
	</div>
</template>

<script>
import XlsExport from '../../../services/xls-export';
import Modal from '../modal/pedidoexport';
import global from '../../../mixins/global';
import * as ecAxios from '../../../util/ecAxios';
import KButton from '../buttons/Default';

export default {
	components: {
		Modal,
		KButton,
	},
	mixins: [global],
	data() {
		return {
			filters: JSON.parse(localStorage.getItem('filters')),
			modalActive: false,
			isLoading: true,
			dados: [],
			downloadLoad: false,
			empresa_id: null,
			formpgto_id: null,
			searchTerm: null,
			situacao: null,
			situacoeslog: null,
			pessoa_id: null,
			orderby: null,
			direction: null,
			situacaoDesc: {
				0: 'Salvo',
				1: 'Finalizado',
				2: 'Integrado',
				3: 'Inválido',
				4: 'Em Análise',
				5: 'Liberado',
				6: 'Faturado',
				7: 'Cancelado',
				8: 'Transporte',
				9: 'Entregue',
				10: 'Aguardando Pagamento',
				11: 'Em rota',
			},
		};
	},
	methods: {
		openModalExport() {
			this.modalActive = true;
		},
		async getPedidosFilter(modalData = null) {
			this.downloadLoad = true;

			this.isLoading = true;
			// Limpar variaveis
			this.empresa_id = null;
			this.formpgto_id = null;
			this.searchTerm = null;
			this.situacao = null;
			this.situacoeslog = null;
			this.pessoa_id = null;
			this.orderby = 'id';
			this.direction = 'desc';
			let onlyDeleted = false;
			let withDeleted = false;
			let onlyInTrash = false;
			const data = JSON.parse(localStorage.getItem('filters'));

			if (data) {
				if (data.pessoa_id) {
					this.pessoa_id = data.pessoa_id;
				}
				if (data.empresa_id) {
					this.empresa_id = data.empresa_id;
				}
				if (data.formpgto_id && data.formpgto_id > 0) {
					this.formpgto_id = data.formpgto_id;
				}
				if (data.searchTerm) {
					this.searchTerm = data.searchTerm;
				}
				if (data.situacao && data.situacao.length > 0) {
					this.situacao = data.situacao;
				}
				if (data.situacoeslog) {
					this.situacoeslog = data.situacoeslog;
				}
				if (data.limit) {
					this.limit = data.limit;
				}
				if (data.offset === 0) {
					this.offset = data.offset;
				}
				if (data.pagenumber) {
					this.pagenumber = data.pagenumber;
				}
				if (data.orderby) {
					this.orderby = data.orderby;
				}
				if (data.direction) {
					this.direction = data.direction;
				}
				if (data.statusdata && data.statusdata === 2) {
					onlyInTrash = true;
				}
				if (data.statusdata && data.statusdata === 1) {
					onlyDeleted = true;
				}
				if (data.withDeleted) {
					withDeleted = true;
				}
			}

			this.limit = this.pagelimit;
			this.offset = this.pagenumber * this.pagelimit - this.pagelimit;
			await ecAxios
				.connection()
				// eslint-disable-next-line no-undef
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDOS}`, {
					pessoa_id: this.pessoa_id,
					empresa_id: this.empresa_id,
					formpgto_id: this.formpgto_id,
					searchTerm: this.searchTerm,
					situacao: this.situacao,
					situacoeslog: this.situacoeslog,
					orderby: this.orderby,
					direction: this.direction,
					only_in_trash: onlyInTrash,
					only_deleted: onlyDeleted,
					with_deleted: withDeleted,
					busca_valores: true,
				})
				.then((response) => {
					if (response.status === 200) {
						const { pedidos } = response.data;
						this.dados = pedidos;
						this.exportExel(modalData, true);
					} else if (response.data.error !== 0) {
						throw new Error(response.data.message);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e,
						type: 'is-danger',
					});
					this.pedidos = [];
					this.isLoading = false;
				});
		},
		/* async getPedidosFilter(modalData = null) {
			this.downloadLoad = true;
			// Limpar variaveis
			const data = JSON.parse(localStorage.getItem('filters'));
			this.empresa_id = null;
			this.formpgto_id = null;
			this.searchTerm = null;
			this.situacao = null;
			this.situacoeslog = null;
			this.pessoa_id = null;
			this.orderby = 'id';
			this.direction = 'desc';

			if (data) {
				if (data.pessoa_id) {
					this.pessoa_id = data.pessoa_id;
				}
				if (data.empresa_id) {
					this.empresa_id = data.empresa_id;
				}
				if (data.formpgto_id && data.formpgto_id > 0) {
					this.formpgto_id = data.formpgto_id;
				}
				if (data.searchTerm) {
					this.searchTerm = data.searchTerm;
				}
				if (data.situacao && data.situacao.length > 0) {
					this.situacao = data.situacao;
				}
				if (data.situacoeslog) {
					this.situacoeslog = data.situacoeslog;
				}
				if (data.orderby) {
					this.orderby = data.orderby;
				}
				if (data.direction) {
					this.direction = data.direction;
				}
			}
			const params = {
				pessoa_id: this.pessoa_id,
				empresa_id: this.empresa_id,
				formpgto_id: this.formpgto_id,
				searchTerm: this.searchTerm,
				situacao: this.situacao,
				situacoeslog: this.situacoeslog,
				orderby: this.orderby,
				direction: this.direction,
				busca_valores: true,
			};

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDOS}`, params)
				.then((response) => {
					if (response.status === 200) {
						const { pedidos } = response.data;
						this.dados = pedidos;
						this.exportExel(modalData, true);
					} else if (response.data.error !== 0) {
						this.$buefy.notification.open({
							message: `${response.data.message}`,
							type: 'is-danger',
						});
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger'
					});
				});
		}, */
		verifyStatusRow(status) {
			if (status === 1) {
				return 'Ativo';
			}
			if (status === 0) {
				return 'Inativo';
			}
			if (status === 2) {
				return 'Arquivado';
			}
			return '~';
		},
		getSintegraStatus(data) {
			let { sintegrastatus, receitastatus } = data;
			const sintegraId = sintegrastatus;
			sintegrastatus = parseInt(sintegrastatus, 10);
			if (sintegrastatus === 1) {
				sintegrastatus = 'Liberado';
			} else if (sintegrastatus === 0 && sintegrastatus !== '') {
				sintegrastatus = 'Bloqueado';
			} else {
				sintegrastatus = '';
			}
			if (receitastatus !== '' && receitastatus !== null) {
				if (receitastatus !== null) {
					receitastatus = `${receitastatus} (RF)`;
				}
				if (sintegrastatus) {
					sintegrastatus = `${`${sintegrastatus} / ${receitastatus}`}`;
				} else {
					sintegrastatus = receitastatus;
				}
			}
			return { sintegrastatus, sintegraId };
		},
		exportExel(data) {
			const newData = [];

			this.dados.map((item) => {
				const newIndex = {
					ID: item.id,
					SITUAÇÃO: this.situacaoDesc[item.situacao],
					'CLI. ID': item.cliente_id,
					'CLI. RAZÃO SOCIAL': item.nomerazao,
					'ID INTEGRAÇÃO': item.integracao_id,
					'EMP FANTASIA': item.empresa_fantasia,
					'EMP. ID': item.empresa_id,
					PAGAMENTO: item.formpgto_desc,
					'TAB. VENDA': item.tabvnd_desc,
					'DATA CRIAÇÃO': this.dateTimeToBrasil(item.created_at),
					'VALOR TOTAL': this.transformToBrl(item.vlrtotalpedido),
				};
				newData.push(newIndex);
				return newIndex;
			});
			let filename = '';
			const xls = new XlsExport(newData);
			if (data.nome !== '') {
				filename = `${data.nome}${data.formato}`;
			} else {
				filename = `${new Date().toLocaleString()}${data.formato}`;
			}
			switch (data.formato) {
				case '.xls':
					xls.exportToXLS(filename);
					break;
				case '.csv':
					xls.exportToCSV(filename);
					break;

				default:
					break;
			}
			this.downloadLoad = false;
		},
	},
};
</script>

<style scoped>
.container-modal-ex {
	display: flex;
	align-items: center;
}
.xlsformat {
	cursor: pointer;
}
.xlsformat {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 30px;
	border: 1px solid #cececea9;
}
.btncancel {
	margin-top: 20px;
	height: 40px;
	margin-right: 15px;
}
.btn-export {
	cursor: pointer;
}
</style>

